import { PROJECT_EXPORT } from '../actions/customProjectActions';

export default (previousState = { filename: null }, { type, payload }) => {
  if (type === PROJECT_EXPORT) {
    return {
      filename: payload.filename
    };
  }
  return previousState;
};



// WEBPACK FOOTER //
// ./src/reducers/project.js